"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const material_1 = require("@angular/material");
const router_1 = require("@angular/router");
const rxjs_1 = require("rxjs");
const map_component_1 = require("./../map.component");
const _4d_mapper_1 = require("4d-mapper");
const map_service_1 = require("../../../commons/map.service");
const BaseComponent_1 = require("../../../commons/BaseComponent");
const epsg_helper_service_1 = require("../../../service/epsg-helper.service");
const Constants_1 = require("../../../commons/Constants");
const scrolling_1 = require("@angular/cdk/scrolling");
const measurement_helper_service_1 = require("../../../service/measurement-helper.service");
const plugin_manager_service_1 = require("../../../service/plugin-manager.service");
const plugins_1 = require("../../../commons/plugins/plugins");
const Cesium = window.Cesium;
class ImageListManager extends BaseComponent_1.BaseComponent {
    constructor(mapComponent, route, router, fourD, snackBar, dialog, mapService, pluginManager, epsgHelper, measureHelper) {
        super(router, snackBar, dialog);
        this.mapComponent = mapComponent;
        this.route = route;
        this.router = router;
        this.fourD = fourD;
        this.mapService = mapService;
        this.pluginManager = pluginManager;
        this.epsgHelper = epsgHelper;
        this.measureHelper = measureHelper;
        this.debug = Constants_1.Constants.debug_off;
        this.debugPrimary = Constants_1.Constants._purple;
        this.debugSecondary = Constants_1.Constants._gray;
        this.images = [];
        this.imagesAll = [];
        this.imagesGrouped = [];
        // SJ quick fix
        this.imagesPlotted = [];
        this.clampToGround = false;
        this.cameraEntities = [];
        this.mouseCheck = null;
        this.counter = 0;
        this.imagePlugins = null;
        this.imagePositionColor = Cesium.Color.WHITE;
        // mapComp: MapComponent
        this.hiddenImages = [];
        this.onlySelectedPositionPhotos = false;
        this.viewPhotosLarge = false;
        this.mouseIsOverBucket = false;
        let me = this;
        this.addSubscription('onPhotosChange', mapService.onPhotosChange().subscribe(photos => {
            if (this.debug) {
                console.log('%c images %c sub -> mapService :: onPhotosChange()', this.debugPrimary, this.debugSecondary);
            }
            photos.forEach(p => {
                if (p['exif_props'] && p['exif_props']['GPano:ProjectionType'] == 'equirectangular') {
                    p['is360'] = true;
                }
                if (p['is360']) {
                    // add image 360 plugin
                    // console.log('images, add 360', p );
                    setTimeout(() => {
                        me.imagePlugins.create('images-360-controller', null, p);
                    }, 4000);
                }
                else {
                    // console.log('images, add',p);
                }
            });
            if (this.mapService.newAnnotation && this.mapService.newAnnotation.photoIds && this.mapService.newAnnotation.photoIds.length > 0) {
                var ids = '';
                this.mapService.newAnnotation.photoIds.map(a => ids += a + '|');
                ids = ids.substr(0, ids.lastIndexOf('|'));
                this.fourD.V.searchByObject(_4d_mapper_1.Transform)
                    .equals('id', ids)
                    .limit(700)
                    .queryObservable().subscribe(s => {
                    if (s.items.length > 0) {
                        for (let p of photos) {
                            if (s.items.findIndex(si => si.id === p.id) !== -1)
                                s.items[s.items.findIndex(si => si.id === p.id)] = p; // hack not getting selected_position when queyrying to Transform so get it from the photos that are passed.
                        }
                        // sort rest of the photos by selected_position value
                        let photosWithPosition = photos.filter(p => p['selected_position'] && p['selected_position']['x'] !== -1 && p['selected_position']['y'] !== -1 && s.items.findIndex(si => si.id === p.id) === -1);
                        let photosWithoutPosition = photos.filter(p => (!p['selected_position'] || !p['selected_position']['x'] || p['selected_position']['x'] === -1 || !p['selected_position']['y'] || p['selected_position']['y'] === -1) && s.items.findIndex(si => si.id === p.id) === -1);
                        photos = photosWithPosition;
                        photos.push(...photosWithoutPosition);
                        s.items.push(...photos);
                        this.lastPositionPhotos = s.items.slice();
                        this.photosFromPin = true;
                        this.filterPhotos(s.items);
                    }
                    else {
                        this.lastPositionPhotos = photos.slice();
                        this.photosFromPin = false;
                        this.filterPhotos(photos);
                    }
                }, error1 => {
                    this.lastPositionPhotos = photos.slice();
                    this.photosFromPin = false;
                    this.filterPhotos(photos);
                });
            }
            else {
                this.lastPositionPhotos = photos.slice();
                this.photosFromPin = false;
                this.filterPhotos(photos);
            }
        }));
        this.addSubscription('onPhotosWillChange', mapService.onPhotosWillChange().subscribe(photos => {
            if (this.debug) {
                console.log('%c images %c sub -> mapService :: onPhotosWillChange()', this.debugPrimary, this.debugSecondary);
            }
            this.loading = true;
        }));
        this.addSubscription('onSceneWillChange', this.mapService.onSceneWillChange().subscribe(s => {
            if (this.debug) {
                console.log('%c images %c sub -> mapService :: onSceneWillChange()', this.debugPrimary, this.debugSecondary);
            }
            if (this.mapService.scene && s !== this.mapService.scene.id) { // if scene load is triggered from photogrammetry then it will trigger onSceneWill change, here if we are in same scene then we dont need to change the list of photos and plot them again
                this.removeThisPlottedImages();
                this.imagePlugins.end();
                this.images = [];
                this.removeAllPlottable();
            }
        }));
        this.addSubscription('showHidePhotos', this.mapService.showHideAllPhotosSub.subscribe(checked => {
            if (this.debug) {
                console.log('%c images %c sub -> mapService :: showHideAllPhotosSub()', this.debugPrimary, this.debugSecondary);
            }
            this.showHideAllPhotos(checked);
            this.mapService.showPhotos[this.mapService.scene.id] = checked;
        }));
    }
    init() {
        let me = this;
        this.imagePlugins = this.pluginManager.createController('images', {
            filterByType: [plugins_1.FdmPlugin.types.imageController],
            createId: function (item) { return 'i_' + item.id; }
        });
        // catch the photo-bucket virtual viewport
        let el = document.getElementById('photo-bucket-viewport');
        if (el) {
            // only scroll the wheel if the mouse is over the photo bucket
            el.onmouseover = function () {
                me.mouseIsOverBucket = true;
            };
            el.onmouseout = function () {
                me.mouseIsOverBucket = false;
            };
            // add a mouse wheel listener
            addEventListener("wheel", function (event) {
                if (me.mouseIsOverBucket) {
                    me.scrollWheelHandler(event);
                }
            });
            addEventListener("resize", function (event) {
                me.refreshImageGroups();
            });
        }
    }
    scrollWheelHandler(event = null) {
        // console.log ( 'scrollWheel', event, this.virtualScroll );
        // let range = this.virtualScroll['_renderedRange']
        let move = Math.round(event.deltaY / 1.3) + this.virtualScroll.measureScrollOffset();
        this.virtualScroll.scrollToOffset(move);
    }
    refreshPhotosFromCurrentCoord(coord = null, check = null) {
        if (check) {
            this.mouseCheck = check;
        }
        this.refreshImageGroups();
        if (this.mouseCheck && this.mouseCheck.vertical_offset) {
            if (this.debug) {
                console.log('%c images %c refreshPhotosFromCurrentCoord() w/offset', this.debugPrimary, this.debugSecondary, coord, this.mouseCheck);
            }
            this.mapService.refreshPhotos(coord, this.mouseCheck.vertical_offset).subscribe();
        }
        else {
            if (this.debug) {
                console.log('%c images %c refreshPhotosFromCurrentCoord()', this.debugPrimary, this.debugSecondary, coord, this.mouseCheck);
            }
            this.mapService.refreshPhotos(coord).subscribe();
        }
    }
    clampingToGround() {
        let clamping = this.clampToGround ? true : false;
        // console.log ( 'clampingToGround() ------------------------------', clamping, this.mapComponent.hangon );
        if (clamping) {
            Constants_1.Constants.showHangOn();
        }
        let allCameras = [];
        this.images.forEach(c => {
            if (c.llng && c.llat) {
                allCameras.push(this.mapService.helper.getCesiumObjectFor(c));
            }
        });
        let now = Cesium.JulianDate.now();
        this.counter = 0;
        let n = 0;
        let max = allCameras.length;
        allCameras.forEach(c => {
            if (c) {
                //   c.point.show = false;
            }
        });
        // heavy calculation intensive section, so a little timeout to allow the UI to update
        setTimeout(() => {
            allCameras.forEach(c => {
                // console.log ( '!--------', this.counter, c);
                if (c) {
                    setTimeout(() => {
                        // let position = c.position;
                        // console.log ( '!1', this.counter, clamping);
                        if (clamping) {
                            // console.log ( '!2', this.counter, c);
                            let pos = c.position.getValue(now);
                            // console.log ( '!3', this.counter, pos);
                            c.position = this.mapService.viewer.scene.clampToHeight(pos, [c]);
                            // console.log ( '!4', this.counter, c);
                            c.point.color = Cesium.Color.YELLOW;
                            // console.log ( "$true ", position, objectsToExclude, pos, test);
                        }
                        else {
                            let img = this.images.find(i => i.id == c['camera_id']);
                            // console.log ( '!5', this.counter, img);
                            if (img) {
                                let test = img.catresian();
                                if (test) {
                                    c.position = test;
                                    c.point.color = this.imagePositionColor;
                                }
                            }
                        }
                        let per = this.realNumber(100 * (this.counter++ / max)) + "%";
                        this.mapComponent.hangon.tell(per);
                        if (this.counter >= max) {
                            this.mapComponent.hangon.tell('');
                            Constants_1.Constants.hideHangOn();
                            allCameras.forEach(c => {
                                if (c) {
                                    c.point.show = true;
                                }
                            });
                        }
                        // console.log ( '!', this.counter);
                    }, n++ * 2);
                    // console.log ( ' @@ ', n, this.counter);
                }
            });
            // console.log ( 'clampingToGround() --------- END ---------------------' );
        }, 150);
    }
    realNumber(x) {
        return Number.parseFloat(x).toFixed(0);
    }
    getCameraEntity(image) {
        if (image['exif_props'] && image['exif_props']['GPano:ProjectionType'] == 'equirectangular') {
            image['is360'] = true;
        }
        let ret = {};
        if (image['is360']) {
            ret = {
                type: 'camera',
                camera_id: image.id,
                is360: true,
                point: {
                    pixelSize: 25,
                    color: Cesium.Color.YELLOW.withAlpha(0.7),
                    outlineColor: Cesium.Color.BLACK.withAlpha(0.5),
                    outlineWidth: 5,
                    disableDepthTestDistance: 1500.0,
                }
            };
        }
        else {
            var pinBuilder = new Cesium.PinBuilder();
            ret = {
                type: 'camera',
                camera_id: image.id,
                /* model: {
                  uri: '/assets/images/camera.glb',
                  minimumPixelSize: 25,
                  maximumScale: 100,
                  scale: 0.005,
                  heightReference: !this.clampToGround ? Cesium.HeightReference.RELATIVE_TO_GROUND : Cesium.HeightReference.NONE,
                  color: Cesium.Color.WHITE.withAlpha(0.7)
                }, */
                point: {
                    pixelSize: 10,
                    color: this.imagePositionColor,
                    outlineColor: Cesium.Color.BLACK.withAlpha(0.5),
                    outlineWidth: 1,
                    disableDepthTestDistance: 1500.0,
                }
            };
        }
        if (image.heading != undefined && image.pitch != undefined && image.roll != undefined) {
            var height = image.uheight;
            var carto = Cesium.Cartographic.fromDegrees(image.llng, image.llat, height);
            var pos = Cesium.Cartographic.toCartesian(carto);
            ret['orientation'] = Cesium.Transforms.headingPitchRollQuaternion(pos, new Cesium.HeadingPitchRoll(Cesium.Math.toRadians(image.heading - 90), Cesium.Math.toRadians(image.pitch), Cesium.Math.toRadians(image.roll)));
        }
        return ret;
    }
    filterPhotos(photos) {
        if (this.debug) {
            console.log('%c images %c filterPhotos() incoming', this.debugPrimary, this.debugSecondary, photos, this.onlySelectedPositionPhotos, this.photosFromPin);
        }
        if (this.onlySelectedPositionPhotos) {
            photos = photos.filter(p => p['selected_position'] && p['selected_position']['x'] !== -1 && p['selected_position']['y'] !== -1);
        }
        else if (!this.photosFromPin) {
            // so, I think this is to push 'withPosition' first, and then without at the end?
            let photosWithPosition = photos.filter(p => p['selected_position'] && p['selected_position']['x'] !== -1 && p['selected_position']['y'] !== -1);
            let photosWithoutPosition = photos.filter(p => !p['selected_position'] || !p['selected_position']['x'] || p['selected_position']['x'] === -1 || !p['selected_position']['y'] || p['selected_position']['y'] === -1);
            photos = photosWithPosition;
            photos.push(...photosWithoutPosition);
        }
        // so, if there's hidden images, unhide them? Why?
        if (this.hiddenImages.length > 0) {
            this.hiddenImages.forEach(i => {
                if (this.mapService.helper.getMapObjectFor(i)) {
                    this.mapService.helper.getMapObjectFor(i).object.show = true;
                }
            });
        }
        if (this.mapService.showPhotos[this.mapService.scene.id]) {
            this.cameraEntities.length = 0;
            var toAdd = photos.filter(p => !this.imagesPlotted.find(i => i.id == p.id));
            var toDel = this.imagesPlotted.filter(p => !photos.find(i => i.id == p.id));
            this.cameraEntities = [];
            // let me = this;
            // if ( this.debug ) { console.log ( '%c images %c filterPhotos() showing images, toAdd, toDel', this.debugPrimary, this.debugSecondary, toAdd, toDel ); }
            rxjs_1.forkJoin(toAdd.map(i => this.mapService.helper.setPlottable(i, { entity: this.getCameraEntity(i) }))).subscribe(cameras => {
                // if ( this.debug ) { console.log ( '%c images %c filterPhotos() got cameras', this.debugPrimary, this.debugSecondary, cameras ); }
                cameras.forEach(c => {
                    let pick = c['object']; // hack of unknown object type
                    this.cameraEntities.push(pick);
                });
            });
            toDel.forEach(i => {
                if (i['is360']) {
                    // remove image 360 plugin
                    // this.imagePlugins.remove(i);
                    console.log('images, remove 360');
                }
                this.mapService.helper.removePlottable(i);
            });
            this.imagesPlotted = photos;
        }
        else {
            this.imagesPlotted.forEach(i => {
                if (i['is360']) {
                    // remove image 360 plugin
                    // this.imagePlugins.remove(i);
                    console.log('images, remove 360');
                }
                this.mapService.helper.removePlottable(i);
            });
            this.imagesPlotted = [];
        }
        if (this.debug) {
            console.log('%c images %c filterPhotos() END', this.debugPrimary, this.debugSecondary, photos, this.hiddenImages);
        }
        this.images = photos;
        this.refreshImageGroups();
        this.loading = false;
        this.clampingToGround();
        /*
        
        
            // var wgs84 = 'EPSG:4326'; // 'GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]]';
            var altcoordsystem = 'PROJCS["GDA_1994_MGA_Zone_56",GEOGCS["GCS_GDA_1994",DATUM["D_GDA_1994",SPHEROID["GRS_1980",6378137.0,298.257222101]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",153.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0]]';
        
            let res = '';
            // let res2 = '';
            // let arr = this.originalImages.values;
        
            photos.forEach(me => {
        
              const coord = [ me['ulng'], me['ulat'] ];
              console.log ( 'conv coord', coord );
              
              // convert from, to, coord
              let conv = this.epsgHelper.convert ( 'EPSG:4326', altcoordsystem, coord );
              console.log ( 'conv coord,conv', me, coord,conv );
                res = res + me['ds_name'] + '\t' + conv[0] + '\t' + conv[1] + '\t' + parseFloat(me['uheight']) + '\t5\t5\t5\n';
                // res2 = res2 + me[0] + '\t' + conv2[0] + '\t' + conv2[1] + '\t' + parseFloat(me[3]) + '\t5\t5\t5\n';
        
            });
            console.log ( '### all images ', res );
        
        
        
        
        */
        if (this.mapService.scene._photo_count == 0) {
            this.mapService.showPhotos[this.mapService.scene.id] = false;
            this.removeAllPlottable();
        }
    }
    refreshImageGroups(viewPhotosLarge = this.viewPhotosLarge) {
        this.viewPhotosLarge = viewPhotosLarge;
        let fitItems = 4;
        let heightOfItem = 145;
        let e = document.getElementById('fdm-photo-bucket');
        if (e) {
            let sizes = e.getBoundingClientRect();
            let height = sizes.height - 80; // 80px is padding and the toolbar
            fitItems = Math.floor(height / heightOfItem);
            let currentSize = (heightOfItem * fitItems) + 80;
            // console.log('@@@@@@', height, fitItems, currentSize );
            // e.style.maxHeight = currentSize + 'px';
            // e.style.height = currentSize + 'px';
        }
        let groupByN = (n, data) => {
            let result = [];
            for (let i = 0; i < data.length; i += n)
                result.push(data.slice(i, i + n));
            return result;
        };
        this.imagesGrouped = groupByN(this.viewPhotosLarge ? fitItems : 1, this.images);
        if (this.debug) {
            console.log('%c images %c refreshImageGroups()', this.debugPrimary, this.debugSecondary, this.viewPhotosLarge, this.imagesGrouped);
        }
    }
    filterAndRefreshTargetedPhotos() {
        if (this.debug) {
            console.log('%c images %c filterAndRefreshTargetedPhotos()', this.debugPrimary, this.debugSecondary, this.mapService.showPhotos[this.mapService.scene.id], this.lastPositionPhotos);
        }
        if (this.mapService.showPhotos[this.mapService.scene.id]) {
            console.log('moveOnTop');
            if (!this.onlySelectedPositionPhotos) {
                this.lastPositionPhotos = null;
            }
            this.moveOnTopLastPhotoAndFilter();
        }
        else {
            if (this.lastPositionPhotos) {
                console.log('lastPos');
                this.filterPhotos(this.lastPositionPhotos);
            }
            else {
                console.log('refreshCurrent');
                this.refreshPhotosFromCurrentCoord();
            }
        }
    }
    browsePhotos() {
        if (this.debug) {
            console.log('%c images %c browsePhotos()', this.debugPrimary, this.debugSecondary);
        }
        this.openDialogWithModeAndFilterAndMeta({
            project: this.mapService.currentProject,
            transform_group: this.mapService.scene.id
        }, 'file_all', 'Dataset', 'PROJECT.DIALOG.ADD_TRANSFORM_TITLE', 'PROJECT.DIALOG.ADD_TRANSFORM_TEXT').subscribe(dest => {
            if (dest instanceof _4d_mapper_1.Folder) {
                if (dest['root'] === 'myFiles')
                    dest.id = -1;
                this.mapService.scene.addImagesFromFolder(dest).subscribe(_ => {
                    this.mapService.refreshPhotos(null).subscribe();
                    this.mapService.scene.fetchObservable().subscribe();
                });
            }
            else if (dest && Array.isArray(dest)) {
                var ds = dest;
                var toAdd = [];
                ds.filter(d => d['canPlot'] && d.dataType.uid != 'photo').forEach(d => d.transformIds.forEach(tid => toAdd.push(this.mapService.scene.children.addObserveable(new _4d_mapper_1.Transform(this.fourD.V).set({ id: tid })))));
                ds.filter(d => d.dataType.uid == 'photo').forEach(d => d.transformIds.forEach(tid => toAdd.push(this.mapService.scene.photos.addObserveable(new _4d_mapper_1.Transform(this.fourD.V).set({ id: tid })))));
                if (toAdd.length)
                    rxjs_1.forkJoin(toAdd).subscribe(_ => {
                        this.mapService.refreshPhotos(null).subscribe();
                        this.mapService.scene.fetchObservable().subscribe();
                    });
                else
                    this.openSnackBarError('PROJECT.DIALOG.NO_ITEMS');
            }
        }, e => this.openSnackBarError(e.message, null));
    }
    nukePhotos() {
        if (this.debug) {
            console.log('images :: nukePhotos()');
        }
        this.openConfirmDelete(() => this.mapService.removeActiveScenePhotos().subscribe(), 'all photos');
    }
    setSelected(a) {
        if (this.debug) {
            console.log('%c images %c setSelected()', this.debugPrimary, this.debugSecondary, a);
        }
        // delselect old one
        if (this.selected) {
            var p = this.mapService.helper.getCesiumObjectFor(this.selected);
            if (p && p.model)
                p.model.color = Cesium.Color.RED;
            if (p && p.point)
                p.point.color = Cesium.Color.RED;
        }
        this.selected = a;
        // if(this.mapService.isCameraClicked){ // set the selected image as a attachement photo
        if (a['is360']) {
            console.log('################ clicked the sphere', a, this.imagePlugins);
            // let plugin = this.pluginManager.
        }
        else {
            this.openDZIDialogWith(a, 'TYPES.photo-dzi');
        }
        /*}else{
          if(a){
            // select new one
            var p = this.mapService.helper.getCesiumObjectFor(this.selected)
            if(p && p.model)
              p.model.color = Cesium.Color.YELLOW
            if(p && p.point)
              p.point.color = Cesium.Color.YELLOW
    
            this.router.navigate([this.fourD.activeUser?'/app/projects/map':'/map',this.mapService.currentProject.id,'image',a.id])
          }
          else{
            this.router.navigate([this.fourD.activeUser?'/app/projects/map':'/map',this.mapService.currentProject.id,'image'])
          }
        }*/
    }
    clickOnImage(feature) {
        if (this.debug) {
            console.log('%c image.comp %c clickOnImage()', this.debugPrimary, this.debugSecondary, feature, feature.transform_id);
        }
        var newSelect;
        if (this.mapService.localPhotos[this.mapService.scene.id]) {
            newSelect = this.mapService.localPhotos[this.mapService.scene.id].find(a => a.id == feature.transform_id);
        }
        else {
            newSelect = this.mapService.scenePhotos.find(a => a.id == feature.transform_id);
        }
        if (newSelect) {
            this.setSelected(newSelect);
        }
    }
    clickedMap(movement, rightClick, checkedPosition) {
        if (this.debug) {
            console.log('%c images.comp %c clickedMap()', this.debugPrimary, this.debugSecondary);
        }
        this.mouseCheck = checkedPosition;
        var feature = this.measureHelper.pickedModel; // this.mapService.viewer.scene.pick(movement.position);
        var def = Cesium.defined(feature);
        if (rightClick)
            this.rightClicked = true;
        else
            this.rightClicked = false;
        if (def && !feature.content && feature.id.transform_id) {
            this.clickOnImage(feature.id);
            return map_component_1.ClickDisplay.None;
        }
        else {
            if (!this.mapService.isCameraClicked && !rightClick) {
                // all else may mean we clicked an image in the photo bucket, and now we want to zoom to that image?
                // update: I think this kicks in if you click an ortho (or other model) when viewing a photogrammetry job (!!!)
                // console.log ( '@@@@@ clickedMap / image', checkedPosition );
                this.refreshPhotosFromCurrentCoord(checkedPosition.coords);
            }
            return rightClick || this.mapService.newAnnotation ? map_component_1.ClickDisplay.None : map_component_1.ClickDisplay.Chevron;
        }
    }
    showHideAllPhotos(checked) {
        if (this.debug) {
            console.log('images :: showHideAllPhotos()', checked);
        }
        if (checked) {
            // hide and reset hidden images
            this.hiddenImages.forEach(i => this.mapService.helper.removePlottable(i));
            this.hiddenImages = [];
            if (!this.mapService.localPhotos[this.mapService.scene.id] || this.mapService.localPhotos[this.mapService.scene.id].length === 0) {
                this.loading = true;
                if (this.debug) {
                    console.log('images :: showHideAllPhotos() - no photos, query');
                }
                this.mapService.scene.photos.limit(701).queryObservable().subscribe(photo => {
                    if (this.debug) {
                        console.log('images :: showHideAllPhotos() - query return', photo.items);
                    }
                    if (photo.items.length > 0) {
                        this.mapService.localPhotos[this.mapService.scene.id] = photo.items;
                        this.mapService.localPhotosReadySub.next();
                        this.processPhotos();
                    }
                    this.loading = false;
                }, error1 => this.loading = false);
            }
            else {
                this.processPhotos();
            }
            // this.images.forEach(i => this.mapService.helper.removePlottable(i));
        }
        else {
            if (this.lastPositionPhotos)
                this.filterPhotos(this.lastPositionPhotos);
            else
                this.refreshPhotosFromCurrentCoord();
            this.hideThisPlottedImages();
            this.removeAllPlottable();
        }
    }
    processPhotos() {
        if (this.debug) {
            console.log('%c images %c processPhotos()', this.debugPrimary, this.debugSecondary);
        }
        this.moveOnTopLastPhotoAndFilter();
        this.removeThisPlottedImages();
        this.plotAllPhotos();
    }
    moveOnTopLastPhotoAndFilter() {
        if (this.debug) {
            console.log('%c images %c moveOnTopLastPhotoAndFilter()', this.debugPrimary, this.debugSecondary, this.mapService.scene.id, this.mapService.localPhotos);
        }
        if (this.mapService.localPhotos && this.mapService.scene.id && this.mapService.localPhotos[this.mapService.scene.id]) {
            if (this.lastPositionPhotos) {
                let localPhotos = this.lastPositionPhotos.slice();
                this.mapService.localPhotos[this.mapService.scene.id].forEach(p => {
                    if (this.lastPositionPhotos.findIndex(pp => pp.id === p.id) === -1) {
                        localPhotos.push(p);
                    }
                });
                this.filterPhotos(localPhotos);
            }
            else {
                this.filterPhotos(this.mapService.localPhotos[this.mapService.scene.id]);
            }
        }
    }
    // remove this components images
    removeThisPlottedImages() {
        if (this.debug) {
            console.log('%c images %c removeThisPlottedImages()', this.debugPrimary, this.debugSecondary);
        }
        this.images.forEach(i => {
            this.mapService.helper.removePlottable(i);
        });
    }
    hideThisPlottedImages() {
        if (this.debug) {
            console.log('%c images %c hideThisPlottedImages()', this.debugPrimary, this.debugSecondary);
        }
        this.images.forEach(i => {
            if (this.mapService.helper.getCesiumObjectFor(i)) {
                this.mapService.helper.getCesiumObjectFor(i).show = false;
                this.hiddenImages.push(i);
            }
        });
    }
    plotAllPhotos() {
        if (this.debug) {
            console.log('%c images %c plotAllPhotos()', this.debugPrimary, this.debugSecondary);
        }
        this.mapService.localPhotos[this.mapService.scene.id].forEach(i => {
            // console.log ( 'plot img', i);
            if (i.llat && i.llng) {
                // var height = args && args.vertical_invert ? args.vertical_invert - p.uheight : p.uheight;
                // var carto = Cesium.Cartographic.fromDegrees(i.llng, i.llat, i.uheight);
                // var pos = Cesium.Cartographic.toCartesian(carto);
                this.mapService.helper.addPlottable(i, { entity: this.getCameraEntity(i) }).subscribe();
            }
        });
    }
    removeAllPlottable() {
        if (this.debug) {
            console.log('%c images %c removeAllPlottable()', this.debugPrimary, this.debugSecondary);
        }
        if (this.mapService.scene && this.mapService.localPhotos[this.mapService.scene.id] && this.mapService.localPhotos[this.mapService.scene.id].length > 0) {
            this.mapService.localPhotos[this.mapService.scene.id].forEach(i => {
                if (this.hiddenImages.findIndex(fi => fi.id == i.id) == -1)
                    this.mapService.helper.removePlottable(i);
            });
        }
    }
}
exports.ImageListManager = ImageListManager;
